import { render } from "./LogoutButton.vue?vue&type=template&id=766e787a&scoped=true"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"

import "./LogoutButton.vue?vue&type=style&index=0&id=766e787a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766e787a"]])

export default __exports__